/**
 * 채널 성과 글 짝짓기 열쇠 — 서버(공개 글 ↔ Windsor 콘텐츠)와 화면(자사 계정 관리 글 ↔ 채널 성과 글)이 같은 규칙을 쓴다.
 * 열쇠는 문서 id(`id:`) → Instagram 글 주소 코드(`code:`) · YouTube/TikTok 영상 id(`video:`) → 주소(`link:`, 쿼리 · 끝 `/` 를 뗀 것) 순이다.
 * ⚠️ YouTube 주소(`watch?v=…`)는 쿼리를 떼면 영상끼리 같아진다 — 영상 id 가 있으면 `link:` 열쇠를 싣지 않는다.
 */

// ----------------------------------------------------------------------

/**
 * Instagram 글 주소의 코드 — `/p/{code}` · `/reel/{code}` · `/reels/{code}` · `/tv/{code}`(앞에 계정 경로가 껴도 된다). 아니면 null.
 * ⚠️ 공유 주소(`/share/p/{토큰}` · `/share/reel/{토큰}`)의 토큰은 글 코드가 아니다 — null.
 */
export function shortcodeOf(link: string | null | undefined): string | null {
  const m = /instagram\.com\/(?!share\/)(?:[^/?#]+\/)?(?:p|reels?|tv)\/([A-Za-z0-9_-]+)/i.exec(link ?? '');
  return m ? m[1] : null;
}

/** YouTube(`watch?v=` · `youtu.be/` · `shorts/` · `embed/` · `live/`) · TikTok(`/video/{id}`) 주소의 영상 id(플랫폼 이름을 붙인다). 아니면 null */
export function videoIdOf(link: string | null | undefined): string | null {
  const url = link ?? '';
  const yt = /(?:youtube\.com\/(?:watch\?(?:[^#]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/i.exec(url);
  if (yt) return `youtube:${yt[1]}`;
  const tt = /tiktok\.com\/[^?#]*\/video\/(\d+)/i.exec(url);
  return tt ? `tiktok:${tt[1]}` : null;
}

/**
 * 글 하나의 짝짓기 열쇠 — 앞의 것일수록 확실하다.
 * @param id 게시물 색인 문서 id(없으면 건너뛴다)
 * @param link 글 주소(없거나 `N/A` 면 건너뛴다)
 * @returns 열쇠 목록(없으면 빈 배열)
 */
export function postMatchKeys(id: unknown, link: unknown): string[] {
  const keys: string[] = [];
  if (typeof id === 'string' && id) keys.push(`id:${id}`);
  const url = typeof link === 'string' ? link.trim() : '';
  if (!url || url === 'N/A') return keys;
  const code = shortcodeOf(url);
  if (code) keys.push(`code:${code}`);
  const video = videoIdOf(url);
  if (video) {
    keys.push(`video:${video}`);
    return keys;
  }
  keys.push(`link:${url.split(/[?#]/)[0].replace(/\/+$/, '')}`);
  return keys;
}
